// src/components/ClientsOnlineDashboard/components/DeleteAnonymousModal.tsx

import React, { useState } from "react";
import "../styles/DeleteAnonymousModal.css";

interface DeleteAnonymousModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedForDelete: { 
    ids: number[]; 
    emails: string[]; 
    deleteAll: boolean;
  };
  loading: boolean;
}

const DeleteAnonymousModal: React.FC<DeleteAnonymousModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedForDelete,
  loading
}) => {
  const [confirmText, setConfirmText] = useState("");

  if (!isOpen) return null;

  const getTitle = () => {
    if (selectedForDelete.deleteAll) return "Supprimer tous les anonymes";
    if (selectedForDelete.ids.length > 1) 
      return `Supprimer ${selectedForDelete.ids.length} anonymes`;
    return "Supprimer cet utilisateur anonyme";
  };

  const getDescription = () => {
    if (selectedForDelete.deleteAll) {
      return "Vous êtes sur le point de supprimer TOUS les comptes anonymes. Cette action est irréversible.";
    }
    if (selectedForDelete.ids.length > 1) {
      return `Vous êtes sur le point de supprimer ${selectedForDelete.ids.length} comptes anonymes.`;
    }
    return `Vous êtes sur le point de supprimer l'utilisateur ${selectedForDelete.emails[0] || 'anonyme'}`;
  };

  const needsConfirmation = selectedForDelete.deleteAll || selectedForDelete.ids.length > 1;

  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="delete-modal">
        <div className="modal-header">
          <h3 className="modal-title">{getTitle()}</h3>
          <p className="modal-description">{getDescription()}</p>
        </div>

        {selectedForDelete.emails.length > 0 && selectedForDelete.emails.length <= 5 && (
          <div className="email-list">
            {selectedForDelete.emails.map((email, idx) => (
              <div key={idx} className="email-item">
                • {email}
              </div>
            ))}
          </div>
        )}

        {needsConfirmation && (
          <div className="confirmation-section">
            <label className="confirmation-label">
              Tapez <strong>SUPPRIMER</strong> pour confirmer
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="confirmation-input"
              placeholder="SUPPRIMER"
            />
          </div>
        )}

        <div className="modal-actions">
          <button
            onClick={onClose}
            className="cancel-button"
            disabled={loading}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={loading || (needsConfirmation && confirmText !== 'SUPPRIMER')}
            className="delete-button"
          >
            {loading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteAnonymousModal;